/** Copy Media Lab — Alter Gold Servicios de Salud × TNO Media Lab */
export const alterGoldMediaLabWho = {
  title: 'TNO Media Lab: producción en casa para Alter Gold Servicios de Salud',
  subtitle:
    'Programa propio, micros en rotativa, clips para redes y promocionales en YouTube — audiencia dirigida a TNO Network.',
  description:
    'TNO Media Lab produce el espacio de Alter Gold en nuestros estudios: monitoreo Tagyp, T.A.G., prevención y Club AlterGold explicados con rigor y cercanía. Rotativa 24/7, clips sociales y piezas YouTube que empujan tráfico a TNO Network.',
};

export const alterGoldMediaLabWhy = {
  title: '¿Por qué producir con TNO Media Lab?',
  description:
    'Un solo partner en TNO: cuatro bloques integrados, publicación en TNO Network, bonificación en Digest y modelo claro de comercialización — 30% a la radio si trae el cliente Alter Gold; 50/50 si lo trae TNO.',
  ctaText: 'Agendar reunión',
};

export const alterGoldMediaLabBenefits = {
  overline: 'Producción TNO',
  title: 'Cuatro bloques, un plan mensual',
  subtitle:
    'Profundidad (programa), recordación (rotativa), alcance social (clips) y promoción (YouTube → TNO Network).',
  items: [
    {
      title: 'Programa en estudio (Bloque 1)',
      subtitle:
        'Producción del programa Alter Gold en TNO Media Lab: grabación, edición y entrega lista para TNO Network.',
      colorKey: 'blue',
    },
    {
      title: 'Micros en rotativa (Bloque 2)',
      subtitle:
        'Piezas sobre prevención, Tagyp y T.A.G. en la rotativa 24/7 de TNO Network.',
      colorKey: 'teal',
    },
    {
      title: 'Clips para redes (Bloque 3)',
      subtitle:
        '12 clips por episodio para Instagram, LinkedIn, TikTok y X — paquete mensual de clips.',
      colorKey: 'amber',
    },
    {
      title: 'YouTube promocional (Bloque 4)',
      subtitle:
        '4 clips promocionales por episodio que impulsan al programa en TNO Network — mismo paquete $50 USD/mes.',
      colorKey: 'pink',
    },
  ],
};

export const alterGoldMediaLabValues = {
  overline: 'Valores del Lab',
  title: 'ADN de la producción',
  hideAdnHeading: true,
  subtitle:
    'Tecnología broadcast, claridad en salud digital y flujo mensual predecible desde el Media Lab de TNO.',
  items: [
    {
      title: 'Producción in-house',
      subtitle: 'Todo se produce en TNO Media Lab con estándar de la red.',
    },
    {
      title: 'Alcance + conversión',
      subtitle:
        'Rotativa y redes generan recordación; YouTube empuja audiencia a TNO Network.',
    },
    {
      title: 'Comercialización',
      subtitle:
        'Opcional: cliente de Alter Gold → 30% para TNO; cliente de la radio → 50/50 por patrocinador cerrado.',
    },
    {
      title: 'Inversión clara',
      subtitle:
        '$230 USD mensuales: programa $100, rotativa $80 y paquete clips $50 (12 redes + 4 YouTube por episodio).',
    },
  ],
};

export const alterGoldMediaLabAreYouReady = {
  headline: 'Activemos la producción para Alter Gold Servicios de Salud',
  subheadline: '¿Listos para el primer ciclo mensual?',
  body:
    'Coordinemos calendario de grabación, micros a rotativa, clips para redes y promocionales en YouTube con destino TNO Network.',
  ctaPrimary: 'Quiero esta propuesta',
  ctaSecondary: 'TNO Media Lab',
  ctaSecondaryHref: '/medialab',
  whatsappNumber: '04123964576',
  footerText:
    '© TNO Network 2026 | Alter Gold Servicios de Salud × TNO Media Lab | The Content Evolution.',
};
